@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.checkbox {
  font-size: 12px;
  height: 14px;
  display: flex;

  input {
    display: none;
  }

  label {
    display: inline-block;
  }

  .label-text {
    position: relative;
    margin-bottom: 0;
    cursor: pointer;
    display: flex;
    vertical-align: top;
    line-height: 18px;
    user-select: none;

    &:before {
      content: '';
      display: inline-block;
      height: 14px;
      width: 14px;
      min-width: 14px;
      border: 1px solid var(--gray-637381);
      background: var(--white);
      position: relative;
      vertical-align: top;
      margin: 2px 8px 0 0;
      border-radius: 2px;
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 4px;
      left: 5px;
      width: 4px;
      height: 8px;
      border: solid transparent;
      border-width: 0 1px 1px 0;
      transform: rotate(45deg);
    }
  }

  &:hover {
    .label-text {
      &:before {
        background: var(--grey-200);
      }
    }
  }

  // TODO SPD-20213: Add focus back when the checkbox supports toggling by keyboard
  //&:focus {
  //  .label-text {
  //    &:before {
  //      outline: 2px solid var(--blue-6AC7FF);
  //      outline-offset: 2px;
  //    }
  //  }
  //}

  &:focus-visible {
    outline: none;
  }

  &.large-checkbox {
    height: 20px;

    .label-text {
      font-size: 14px;
      line-height: 20px;
      text-align: left;

      &:before {
        width: 20px;
        height: 20px;
        margin-top: 0;
        min-width: 20px;
      }

      &:after {
        top: 4px;
        left: 7px;
        width: 5px;
        height: 10px;
      }
    }
    &.indeterminate {
      .label-text {
        &:after {
          top: 4px;
          left: 5px;
          width: 10px;
        }
      }
    }
  }

  &.checked:not(&.disabled),
  &.indeterminate:not(&.disabled) {
    .label-text {
      &:before {
        background: @checkbox--checked--background-color;
        border: 1px solid transparent;
      }

      &:after {
        border-color: var(--white);
      }
    }
    &:hover {
      .label-text {
        &:before {
          border: 1px solid var(--blue-900);
        }
      }
    }
  }

  &.disabled {
    color: @checkbox--disabled--text-color;

    .label-text {
      cursor: default;

      &:before {
        background-color: var(--grey-300);
        border: 1px solid var(--grey-400);
      }
    }

    &.checked {
      .label-text {
        &:after {
          border-color: var(--grey-500);
        }
      }
    }
  }

  &.indeterminate {
    .label-text:after {
      top: 1px;
      left: 3px;
      width: 8px;
      height: 7px;
      border-width: 0 0 1px;
      transform: none;
    }
  }

  &.no-text {
    .label-text {
      &:before {
        margin: 0;
      }
      &:after {
        top: 2px;
      }
    }
  }
}
